export default "__VITE_ASSET__B56vG3A0__"